import { render } from "./RatingBullet.vue?vue&type=template&id=3c035296"
import script from "./RatingBullet.vue?vue&type=script&lang=js"
export * from "./RatingBullet.vue?vue&type=script&lang=js"

import "./RatingBullet.vue?vue&type=style&index=0&id=3c035296&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__